module.exports = __webpack_public_path__ + "static/may-4-9bb59848a9d85b97838423035dca81b7.png";